import { render, staticRenderFns } from "./chooseDialog.vue?vue&type=template&id=6ce79720"
import script from "./chooseDialog.vue?vue&type=script&lang=js"
export * from "./chooseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports